<div class="col-md-12">
  <div class="profile-pic text-center">
    <div class="img-box">
      <img [src]="getImageUrl(userDetail.profilepicFilepath)" class="img-fluid" />
      <ul>
        <a href={{userDetail.facebookUrl}}
          ><li><i class="fab fa-facebook"></i></li
        ></a>
        <a href={{userDetail.twitterUrl}}
          ><li><i class="fab fa-twitter"></i></li
        ></a>
        <a href={{userDetail.linkedinUrl}}
          ><li><i class="fab fa-linkedin"></i></li
        ></a>
      </ul>
    </div>
    <h2>{{userDetail.full_name}}</h2>
    <h3>{{userDetail.position}}</h3>
    <!-- Need to add Router Link -->
    <a class="btn btn-viewprofile" (click)="getAgentPageUrl(userDetail.full_name)">View Profile</a>
  </div>
</div>


